<template>
  <div ref="appContainer" class="app-container">
    <el-row :gutter="20">
      <el-col :offset="8" :span="8">
        <el-form ref="form" label-width="80px" :model="user" :rules="rules">
          <div class="text-center">
            <userAvatar :user="user" />
          </div>
          <ul class="list-group list-group-striped">
            <li class="list-group-item">
              <span>员工姓名：</span>
              <span class="item-content">{{ user.userName }}</span>
            </li>
            <li v-if="showMobile" class="list-group-item">
              <span class="before-item">手机号码：</span>
              <span class="item-content">{{ user.userPhone }}</span>
              <el-button class="ml10" type="text" @click="editmobile">
                修改
              </el-button>
            </li>
            <li v-else class="list-group-item">
              <el-form-item
                label="手机号码:"
                label-width="90px"
                prop="userPhone"
              >
                <el-input
                  v-model="user.userPhone"
                  maxlength="11"
                  style="width: 160px"
                />
                <el-button class="ml10" type="text" @click="close">
                  取消
                </el-button>
                <el-button type="text" @click="Submit">保存</el-button>
              </el-form-item>
            </li>
            <li class="list-group-item">
              <span>所属部门：</span>
              <span v-if="user.deptFullName" class="item-content">
                {{ user.deptFullName }}
              </span>
            </li>
            <li class="list-group-item">
              <span>所属角色：</span>
              <span v-if="user.roleName" class="item-content">
                {{ user.roleName }}
              </span>
            </li>
            <li class="list-group-item">
              <span>创建日期：</span>
              <span class="item-content">{{ user.createTime }}</span>
            </li>
          </ul>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import userAvatar from './userAvatar'
  import { getProfileUser, getProfileEdit } from '@/api/setting/system/user'

  export default {
    name: 'UserDetail',
    components: { userAvatar },
    data() {
      const validatePhoneNumber = (rule, value, callback) => {
        const regexCN = /^1[3-9]\d{9}$/ // 中国大陆手机号正则
        const regexHK = /^[56789]\d{7}$/ // 香港手机号正则
        const regexTW = /^[9]\d{8}$/ // 台湾手机号正则
        const regexMO = /^6\d{7}$/ // 澳门手机号正则

        if (
          regexCN.test(value) ||
          regexHK.test(value) ||
          regexTW.test(value) ||
          regexMO.test(value)
        ) {
          callback() // 符合条件，通过校验
        } else {
          callback(new Error('请输入有效的中国大陆、香港、澳门或台湾手机号码')) // 不符合条件，不通过校验
        }
      }
      return {
        user: {},
        userinfoPhone: '',
        activeTab: 'userinfo',
        pwdOpen: false,
        pwdTitle: '修改账号密码',
        showMobile: true,
        // 表单校验
        rules: {
          userPhone: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePhoneNumber,
            },
          ],
        },
        userId: Number(localStorage.getItem('userId')),
      }
    },
    computed: {
      ...mapGetters(['sidebarRouters', 'sidebar']),
    },
    created() {
      this.getUser()
    },
    methods: {
      getUser() {
        getProfileUser({ userId: this.userId }).then((response) => {
          this.user = response.data
          this.userinfoPhone = response.data.userPhone
        })
      },
      close() {
        let that = this
        that.user.userPhone = this.userinfoPhone
        that.showMobile = true
      },
      Submit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            getProfileEdit({ userPhone: this.user.userPhone }).then((res) => {
              if (res.code == 200) {
                this.msgSuccess('修改成功')
                this.getUser()
                this.showMobile = true
              }
            })
          }
        })
      },
      editmobile() {
        this.showMobile = false
      },
    },
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .list-group-striped {
    .list-group-item {
      padding: 0px 12px;
      line-height: 58px;
      .item-content {
        margin-left: 25px;
      }
      .el-form-item {
        margin: 11px 0;
      }
      .el-input--medium {
        margin-left: 12px;
      }
      .el-input {
        width: 95%;
      }
      .item-mobile .el-form-item__label {
        font-weight: normal;
        text-align: left;
      }
      .el-form-item__error {
        padding-left: 12px;
      }
    }
  }
</style>
